/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type CandidateEntity, candidateSchema } from '@axiom/domain';
import { calendarDtoSchema } from './calendar-dto';

export const interviewCandidateDtoSchema = candidateSchema.pick({ "id": true, "profileImageKey": true, "profileImageName": true }).extend({ "calculatedDisplayName": z.string().nullish(), "calendar": z.lazy(() => calendarDtoSchema).nullish(), "email": z.string().nullish() });
export type InterviewCandidateDto = Pick<CandidateEntity, "id" | "profileImageKey" | "profileImageName"> & z.infer<typeof interviewCandidateDtoSchema>;
